module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgMTggMTIiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTh2MTJIMHoiLz48cGF0aCBmaWxsPSIjZDAwYzMzIiBkPSJNMCA2aDE4djZIMHptMyAwYTQgNCAwIDAgMCA4IDAgNCA0IDAgMCAwLTggMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/grl.svg
// module id = FMQl
// module chunks = 0